
export default class DestinationHotel {
  static fromJSON (jsonHotel) {
    return new DestinationHotel({
      code: jsonHotel.code,
      name: jsonHotel.name,
      brand: jsonHotel.brand,
      memberOnlyRate: jsonHotel.memberOnlyRate,
      coordinates: jsonHotel.coordinates,
      distance: jsonHotel.distance,
      amenities: (jsonHotel.services || []).map((it) => Amenity.fromJSON(it)),
      rating: jsonHotel.rating,
      type: jsonHotel.type,
      types: (jsonHotel.types || []).map((it) => HotelType.fromJSON(it))
    })
  }

  constructor({ code, name, brand, memberOnlyRate, distance, amenities, rating, type, types, price, formattedPrice }) {
    if (!code) throw new Error('code is undefined')
    if (!brand) throw new Error('brand is undefined')

    this.code = code
    this.name = name
    this.brand = brand
    this.memberOnlyRate = memberOnlyRate
    this.distance = distance
    this.amenities = amenities || []
    this.rating = rating
    this.type = type
    this.types = types
    this.price = price || 0
    this.formattedPrice = formattedPrice || ''
  }

  addPrice (price, formattedPrice) {
    return new DestinationHotel({ ...this, price, formattedPrice })
  }

  addRating (rating) {
    return new DestinationHotel({ ...this, rating })
  }
}

class Amenity {
  static fromJSON (json) {
    return new Amenity({
      code: json.code,
      name: json.name
    })
  }

  constructor({ code, name }) {
    this.code = code
    this.name = name
  }
}

class HotelType {
  static fromJSON (json) {
    return new HotelType({
      code: json.code,
      name: json.name
    })
  }

  constructor({ code, name }) {
    this.code = code
    this.name = name
  }
}
